(() => {
  class SearchaniseMenu extends HTMLElement {
    constructor() {
      super();

      // settings
      this.activeClasses = ['search-menu--active'];
      this.desktopBp = window.matchMedia('(min-width: 1024px)');
      this.inputTimer = null;
      this.isDesktopSearch = this.classList.contains('hide-mobile');
      this.isMobileSearch = this.classList.contains('hide-desktop');
      this.isResponsiveSearch = !this.isMobileSearch && !this.isDesktopSearch;
      this.searchaniseMenuMoved = false;
      this.selector = 'search-menu';

      // els
      this.backdropEl = this.querySelector('[data-search-menu-backdrop]');
      this.closeEl = this.querySelector('[data-search-menu-close]');
      this.inputEl = this.querySelector('[data-search-menu-query]');
    }

    connectedCallback() {
      this.listeners();
    }

    close() {
      document.documentElement.classList.remove(...this.activeClasses);

      window.lockScrollDisable();
      // requestAnimationFrame(() => {
      //   const focusEl = this.openEl ? this.openEl : null
      //   window.removeTrapFocus(focusEl);
      // });
    }

    listeners() {
      // listen for search-toggle opens
      window.subscribe(PUB_SUB_EVENTS.searchToggle, event => {
        this.openEl = event.el;
        // window.trapFocus(this, this.inputEl);
        this.inputEl.focus();
        if (!this.searchaniseMenuMoved) this.watchForSearchanise();
      });

      // close search with backdrop
      this.backdropEl.addEventListener('click', e => {
        this.close();
      });

      // close search with X
      this.closeEl.addEventListener('click', e => {
        this.close();
      });

      // close with esc on keyboard
      window.addEventListener('keyup', evt => evt.code === 'Escape' && document.documentElement.classList.contains(this.activeClasses[0]) && this.close());
    }

    moveSearchanise() {
      this.appendChild(document.getElementById('snize-instant-search-results'))
      this.searchaniseMenuMoved = true;
    }

    watchForSearchanise() {
      const observerCallback = (mutationList, observer) => {
        const searchaniseMenuEl = document.querySelector('#snize-instant-search-results');
        if (!searchaniseMenuEl) return;

        setTimeout(() => {
          this.moveSearchanise();
        }, 250);

        this.observer.disconnect();
      };

      this.observer = new MutationObserver(observerCallback);
      this.observer.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }
  }

  class SearchaniseToggle extends HTMLElement {
    constructor() {
      super();
      this.activeClasses = ['search-menu--active', 'suggestions--active'];
      this.desktopSource = 'search-toggle';
      this.el = this.querySelector('[data-search-menu-toggle]');
      this.isMobileToggle = this.hasAttribute('data-search-toggle-mobile');
      this.menuSelector = 'searchanise-menu';
      this.mobileSource = 'mobile-search-toggle';
    }

    connectedCallback() {
      this.hasSearchMenu = document.querySelector(this.menuSelector) !== null;
      // this.trapFocusContainer = document.querySelector(this.menuSelector);
      // this.trapFocusEl = document.querySelector(`${this.menuSelector} [data-search-menu-query]`);
      this.listeners();
    }

    listeners() {
      this.el?.addEventListener('click', e => {
        if (!this.hasSearchMenu) return;
        e.preventDefault();

        document.documentElement.classList.add(...this.activeClasses);
        window.lockScrollEnable();

        window.publish(PUB_SUB_EVENTS.searchToggle, {
          el: this.el,
          source: this.desktopSource,
        });
      });
    }
  }

  if (!customElements.get('searchanise-menu')) {
    customElements.define('searchanise-menu', SearchaniseMenu);
  }

  if (!customElements.get('searchanise-toggle')) {
    customElements.define('searchanise-toggle', SearchaniseToggle);
  }
})();
